import React, { useState, useMemo, useEffect, useCallback, useContext } from "react";
import useSWR from "swr";
import _ from "lodash";
import { fetcher, commentsFetcher, makeRequest } from "../../utils/request";
import getEnvEndpoints from "../../utils/endpoints";
import InfiniteScroll from "react-infinite-scroller";
import CardSwitcher from "../cards/CardSwitcher";
import NotFoundForm from "../layout/NotFoundForm";
import Footer from "../layout/Footer";
import ShareModal from "../common/ShareModal";
import LoginForm from "../layout/LoginForm";
import Modal from "../common/Modal";
import TopNav from "../layout/TopNav";
import FiltersModal from "../common/FiltersModal";
import LogService from "../../utils/logs";
import constants from "../../config/constants";
import GraceBanner from "../landingpage/GraceBanner";
import FreePeriodBanner from "../common/FreePeriodBanner";
import FeedbackBanner from "../common/FeedbackBanner";
import MemberBanner from "../common/MemberBanner";
import { trackPageView } from "../../utils/adobeAnalytics";
import moment from "moment";
import AppContext from "../AppContext";
import Fragment from '../cards/common/Fragments';
import { setPmbok7Link, getExcludeSearchKey, getItemNames } from "../../utils/helper";
import SideNavigationModalLinks from "../layout/SideNavigationModalLinks"
import FeedbackForm from "../layout/FeedbackForm";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj, getAdobeAnalyticsPaginationObj } from '../../analytics/analyticsObject';
import { getUrlWithoutPathname } from '../../utils/utility';

const HomePage = ({
    isAuthenticated,
    myPlan,
    freeUntil,
    userId,
    hasAccessUntil,
    gracePeriod,
    isMember,
    userPermission, hasAccess
}) => {
    // Home Page States
    const [responseError, setResponseError] = useState(false);
    const [showFeedbackAlert, setShowFeedbackAlert] = useState(false);
    const isFree = moment(freeUntil).isAfter(moment());
    const endpoints = getEnvEndpoints();
    const showPmbok7Link = setPmbok7Link(endpoints);
    const showBanner = endpoints && endpoints?.showBanner === 'true' ? true : false
    const bannerMessage = {
        memberBannerMessage: endpoints && endpoints?.memberBannerMessage || '',
        nonMemberBannerMessage: endpoints && endpoints?.nonMemberBannerMessage || ''
    }
    const [contentItemsPosts, setContentItemsPosts] = useState([]);
    const [enableScroll, setEnableScroll] = useState(true)
    const [isPmbokModalVisible, setIsPmbokModalVisible] = useState(false);
    const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);
    const [isShareModalVisible, setIsShareModalVisible] = useState(false);
    const [isFeedbackModalVisible, setIsFeedbackModalVisible] = useState(false);
    const [isPmbokTocModalVisible, setIsPmbokTocModalVisible] = useState(false);
    const [isFeedbackSentModalVisible, setIsFeedbackSentModalVisible] = useState(false);
    const [sharePost, setSharePost] = useState();
    const [feedbackContentKey, setFeedbackContentKey] = useState("");
    const [feedbackPost, setFeedbackPost] = useState("");
    const [feedbackSentContentKeys, setFeedbackSentContentKeys] = useState([]);
    const [downloadedContentKeys, setDownloadedContentKeys] = useState([]);
    const [modalData, setModalData] = useState("");
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showMobileSearch, setShowMobileSearch] = useState(false);
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [appliedFilters, setAppliedFilters] = useState([]);
    const [appliedSearch, setAppliedSearch] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [pages, setPages] = useState([]);
    const [nPage, setNPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(0);
    const [appliedSearchKey, setAppliedSearchKey] = useState('');
    const [appliedFilterKey, setAppliedFilterKey] = useState([]);
    const [locationHash, setLocationHash] = useState('');
    const [filtersUpdate, setFiltersUpdate] = useState(false);
    const [UserDetails, setUserDetails] = useState('');
    const [searchresultsCount, setsearchresultsCount] = useState();
    let subStatus = "";
    // Adobe Analytics Start
    const { isFirstRender, setIsFirstRender } = useContext(AppContext);
    useEffect(() => {
        if (!isFirstRender) {
            trackPageView({ eVar4: "homepage" });
        } else {
            setIsFirstRender(false);
        }
        if (hasAccess && hasAccess == true) {
            if (isMember == true) {
                subStatus = "subscribed:pmi_membership"
            }
            else {
                subStatus = "subscribed:stdplus_subscription"
            }
        }
        else {
            subStatus = "Non-subscribed"
        }
        if (isAuthenticated) {
            let loginData = {
                event: 'loggedin',
                eventInfo: 'loggedin',
                user: {
                    membershipTier: userPermission?.isMember?.membership,
                    membershipStatus: userPermission?.isMember?.isMember == true ? 'active' : 'expired',
                    pmiID: userId
                }
            }
            let searchOnLoad = {
                event: "search-load",
                eventInfo: "search-load",
                action: "search-success",

                search: {
                    searchTerm: "all",
                    searchResults: '10',
                    searchFilter: "not available",
                    searchSort: "relevance",
                    searchType: "standadrplus",
                    searchPagination: "1",
                },

            }
            let subscriptionStatus = {
                event: "sd-app-load",
                eventInfo: "sd-app-load",
                sd: {
                    renewalDate: subStatus === "Non-subscribed" ? "Not available" : hasAccessUntil.split('T')[0],
                    subStatus: subStatus
                }
            }

            pushDatatoAdobeLayer({ searchOnLoad, loginData, subscriptionStatus, pageData: false })
        }
    }, []);
    const onPagination = (pageNo) => {
        let contEventObj = getAdobeAnalyticsEventObject(
            "pagination",
            "pagination",
        );
        let contObj = getAdobeAnalyticsPaginationObj({
            pagination: {
                paginationStep: pageNo
            }
        });
        let linkUrl = `${getUrlWithoutPathname()}`
        let customLObj = getAdobeAnalyticsCustomLinkObj(
            'pagination',
            "home-page",
            linkUrl
        );
        let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
        pushDatatoAdobeLayer({
            onContClickData: { ...contEventObj, ...contObj },
            customLinkData: { ...customEventObj, ...customLObj },
            pageData: false,
            adobePushTracking: false,
        });

    }
    // Adobe Analytics End
    // Home Page API calls
    const swrOptions = {
        revalidateOnFocus: false,
        onError: (err, key, config) => {
            setResponseError({ err, key, config });
        },
        onSuccess: () => {
            setResponseError(false);
        },
    };
    const { data: getplaylistwithlikes } = useSWR(isAuthenticated ? "/api/playlist/getplaylistwithlikes" : [], fetcher, swrOptions);
    const { data: lookup } = useSWR("/api/lookup", fetcher, swrOptions);
    const { data: feedbacks } = useSWR(["/api/Comment/Query", constants.commentTypes.feedback], commentsFetcher);
    const userLikes = getplaylistwithlikes?.userLikes || [];
    const playlists = getplaylistwithlikes?.playlists || null;
    const isLoading =
        !contentItemsPosts || !userLikes || !lookup || !playlists || !feedbacks || !enableScroll;
    // Home Page helpers
    const canProceed = useCallback(() => {
        if (isAuthenticated) {
            return true;
        }
        setIsLoginModalVisible(true);
        return false;
    }, [isAuthenticated]);
    const updateSearchValue = (value) => {
        const pattern = /(\s|^)((\d+\.)(\d+\.?)+)(\s|$)/g;
        const searchValue = value.replace(pattern, '$1"$2"$5')
        setSearchValue(searchValue.trim());
    };
    const showPmbokModal = (htmlData, title) => {
        document.querySelector("body").classList.add("overflow-hidden");
        setModalData(htmlData);
        setIsPmbokModalVisible(true);
    };
    const showFeedbackModal = (post) => {
        setFeedbackPost(post);
        setFeedbackContentKey(post.contentKey);
        setIsFeedbackModalVisible(true);
    };
    const closeFeedbackModal = () => {
        setFeedbackPost("");
        setFeedbackContentKey("");
        setIsFeedbackModalVisible(false);
        setIsPmbokTocModalVisible(false);
    };
    const showShareModal = (post) => {
        setSharePost(post);
        setIsShareModalVisible(true);
    };
    const submitSearch = () => {
        setAppliedSearch(searchValue);
    };
    const cardFilterSelected = (filter) => {
        if (!canProceed()) return;
        if (appliedFilters.filter((fil) => fil.key === filter.key).length === 0) {
            setAppliedFilters([...appliedFilters, filter]);
        }
        if (selectedFilters.filter((fil) => fil.key === filter.key).length === 0) {
            setSelectedFilters([...selectedFilters, filter]);
        }
    };
    const feedbackSent = () => {
        if (!feedbackSentContentKeys.includes(feedbackContentKey)) {
            setFeedbackSentContentKeys([
                ...feedbackSentContentKeys,
                feedbackContentKey,
            ]);
        }
        setFeedbackContentKey("");
        setIsFeedbackModalVisible(false);
        setIsFeedbackSentModalVisible(true);
        setShowFeedbackAlert(false);
        document.querySelector("body").classList.remove("overflow-hidden");
    };
    const isFilterModalVisible =
        showFiltersModal || appliedFilters.length > 0 || showMobileSearch;
    const toggleFiltersModal = (showsModal) => {
        setShowFiltersModal(showsModal);
        if (showsModal) {
            return document.querySelector("body").classList.add("overflow-hidden");
        }
        document.querySelector("body").classList.remove("overflow-hidden");
    };
    const filters = useMemo(() => {
        if (!lookup || !contentItemsPosts) {
            return {};
        }
        const filterableFields = ["PMApproach", "Industry", "MediaType", "Topic", "SubTopic"];
        const filtersBlacklist = ["PMNotSpecific", "INotApplicable", "MTDocument"];
        const availableLookup = lookup.filter(
            (i) => !filtersBlacklist.includes(i.key)
        );
        let availableFilters = _.pick(
            _.groupBy(availableLookup, "group"),
            filterableFields
        );
        let sortedFilters = {};
        Object.keys(availableFilters).forEach((key) => {
            sortedFilters[key] = _.sortBy(availableFilters[key], (o) => {
                return o.title;
            });
        });
        setFiltersUpdate(true);
        return sortedFilters;
    }, [lookup, contentItemsPosts]);
    const checkFilterKey = (arr1, arr2) => {
        if (arr1.length != arr2.length)
            return false
        arr1.sort()
        arr2.sort()
        for (var i = 0; i < arr1.length; i++)
            if (arr1[i] != arr2[i])
                return false
        return true
    }
    const decodeURISafely = (uri) => {
        try {
            return decodeURI(uri);
        } catch (e) {
            return uri;
        }
    }
    // Home Page useEffects
    useEffect(() => {
        if (window.location.hash !== '' && filtersUpdate === true) {
            setLocationHash(window.location.hash);
            const hash = window.location.hash
            const allFilters = _.flatten(Object.values(filters));
            const hashedFilters = allFilters.filter((f) =>
                hash.includes(f.key)
            );
            setSelectedFilters(hashedFilters);
            setAppliedFilters(hashedFilters);
        }
    }, [filtersUpdate]);

    useEffect(() => {
        const hash = window.location.hash.replace("#", "");
        if (hash && Object.keys(filters).length) {
            let filterKeys = hash.split(",");
            const lastFilterKey = filterKeys[filterKeys.length - 1];
            if (lastFilterKey.includes("search=")) {
                let searchParam = filterKeys.pop();
                let searchWord = decodeURISafely(searchParam.split("=").pop());
                updateSearchValue(searchWord);
                setAppliedSearch(searchWord);
            };
        }
    }, [filters]);

    useEffect(() => {
        let filtersHash = "",
            searchHash = "";
        if (Object.keys(filters).length) {
            filtersHash = appliedFilters.map((f) => f.key).join(",");
            if (appliedSearch) {
                searchHash = "search=" + appliedSearch;
                window.location.hash = [filtersHash, searchHash].join(",");
            } else {
                window.location.hash = filtersHash;
            }
        }
    }, [filters, appliedFilters, appliedSearch]);
    useEffect(() => {
        setContentItemsPosts([]);
        setPages([]);
    }, [appliedSearch, appliedFilters])
    useEffect(() => {
        if (isAuthenticated) {
            LogService.logPageVisit({
                contentKey: constants.pageKeys.home,
                contentSubType: constants.contentSubTypes.page,
            });
        }
        let filterGroup = _(appliedFilters)
            .groupBy(x => x.group)
            .map((value, key) => {
                return ({
                    filterkey: key,
                    filtervalue: _.map(value, (val, key) => {
                        if (val) {
                            return value[key].key
                        }
                    }).toString()
                })
            })
            .value();
        const excludeValue = "CTVerbatim,CTToc";
        const excludeFiltersDefault = [{
            filterkey: "contenttypeid",
            filtervalue: null,
            excludevalue: excludeValue
        }]
        const excludeFiltersLoad = (filterGroup.length || appliedSearch !== "")
            ? filterGroup : excludeFiltersDefault;
        const newPageData = {
            filters: excludeFiltersLoad,
            language: "En",
            page: nPage,
            pageSize: 10,
            searchText: appliedSearch,
            sortBy: "publisheddate",
            sortType: "desc",
        }
        const asyncContentItemsPosts = async (data) => {
            setEnableScroll(false);
            const contentItems = await makeRequest("POST", `/api/content/contentItems`, data);
            if (contentItems.currentPage !== 1) {
                onPagination(contentItems.currentPage)

            }
            if (contentItems !== []) {
                const totalPages = contentItems?.totalPages || 0;
                setPageLimit(totalPages);
                if (newPageData.searchText !== '') {
                    setsearchresultsCount(contentItems.totalCount)
                }
            }
            setContentItemsPosts(contentItemsPosts => [...contentItemsPosts, ...contentItems.contentItems]);
            if (appliedSearch !== appliedSearchKey || !checkFilterKey(appliedFilters, appliedFilterKey)) {
                if (appliedSearch !== appliedSearchKey) {
                    setAppliedSearchKey(appliedSearch)
                }
                if (!checkFilterKey(appliedFilters, appliedFilterKey)) {
                    setAppliedFilterKey(appliedFilters)
                }
                setPages([...contentItems.contentItems]);
            } else {
                setPages([...pages, ...contentItems.contentItems]);
            }
            setEnableScroll(true);
        }
        if (appliedSearch !== appliedSearchKey || !checkFilterKey(appliedFilters, appliedFilterKey)) {
            setNPage(1)
            setContentItemsPosts([]);
            setPages([]);
        }
        asyncContentItemsPosts(newPageData)
    }, [isAuthenticated, nPage, appliedSearch, appliedFilters, locationHash]);
    if (responseError) {
        return (
            <div className="pt-32 px-4 text-red-700 text-center">
                There was a problem retrieving data from the server.
            </div>
        );
    }
    window.onscroll = function () {
        if (((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 1000) && enableScroll === true) {
            if (nPage < pageLimit) {
                setEnableScroll(false)
                setNPage(nPage + 1)
            }
        }
    }
    return (
        <div>
            {isPmbokModalVisible && (
                <Modal onClose={() => setIsPmbokModalVisible(false)} onClickOutside={true}>
                    <Fragment data={modalData} />
                </Modal>
            )}
            {isLoginModalVisible && (
                <Modal onClose={() => setIsLoginModalVisible(false)}>
                    <LoginForm refresh={true} />
                </Modal>
            )}
            {isFilterModalVisible && (
                <FiltersModal
                    canProceed={canProceed}
                    showMobileSearch={showMobileSearch}
                    showFiltersModal={showFiltersModal}
                    setShowFiltersModal={toggleFiltersModal}
                    selectedFilters={selectedFilters}
                    setSelectedFilters={setSelectedFilters}
                    appliedFilters={appliedFilters}
                    setAppliedFilters={setAppliedFilters}
                    filters={filters}
                    searchProps={{
                        searchValue,
                        setSearchValue: updateSearchValue,
                        appliedSearch,
                        setAppliedSearch,
                        submitSearch,
                    }}
                />
            )}
            {isShareModalVisible && (
                <ShareModal
                    post={sharePost}
                    onClose={() => setIsShareModalVisible(false)}
                />
            )}
            <SideNavigationModalLinks showPmbok7Link={showPmbok7Link} feedbackPost={feedbackPost} feedbacks={feedbacks} />
            {isFeedbackModalVisible && (
                <Modal onClose={closeFeedbackModal}>
                    <FeedbackForm
                        post={feedbackPost}
                        contentKey={feedbackContentKey}
                        onSubmit={() => feedbackSent()}
                        feedbacks={feedbacks}
                    />
                </Modal>
            )}
            <TopNav
                isAuthenticated={isAuthenticated}
                canProceed={canProceed}
                showMobileSearch={showMobileSearch}
                setShowMobileSearch={setShowMobileSearch}
                showFiltersModal={showFiltersModal}
                setShowFiltersModal={toggleFiltersModal}
                isFilterModalVisible={isFilterModalVisible}
                searchresultsCount={searchresultsCount}
                isMember={isMember}
                hasAccessUntil={hasAccessUntil}
                searchProps={{
                    searchValue,
                    setSearchValue: updateSearchValue,
                    appliedSearch,
                    setAppliedSearch,
                    submitSearch,
                }}
            />
            <div className="pt-20">
                {
                    showBanner && (
                        !isMember ? (
                            <FreePeriodBanner isFree={isFree} freeUntil={freeUntil} bannerMessage={bannerMessage} />
                        ) : (
                            <MemberBanner isFree={isFree} freeUntil={freeUntil} bannerMessage={bannerMessage} />
                        )
                    )
                }
                {showFeedbackAlert && (
                    <FeedbackBanner
                        setShowFeedbackAlert={setShowFeedbackAlert}
                        setIsFeedbackModalVisible={setIsFeedbackModalVisible}
                    />
                )}
            </div>
            <div className="mt-3">
                <GraceBanner
                    hasAccessUntil={hasAccessUntil}
                    gracePeriod={gracePeriod}
                />
            </div>
            <div
                className="md:pt-22"
                id="contents"
            >
                {myPlan && (
                    <div className="pb-5 flex justify-center">
                        <GraceBanner plan={myPlan} />
                    </div>
                )}
                <div className="container mx-auto px-4">
                    <div className="flex -mx-5 justify-center">
                        <div
                            className="w-full lg:flex-1 px-5 lg:px-8"
                            style={{ maxWidth: "730px" }}
                        >
                            {pages.length || isLoading ? (
                                <>
                                    <InfiniteScroll
                                        pageStart={0}
                                        hasMore={true}
                                        loadMore={function () { return (null) }}
                                        loader={
                                            !enableScroll ? (
                                                <h3
                                                    key="loading posts"
                                                    className="text-gray-400 text-center mb-8"
                                                >
                                                    <i className="fas fa-spin fa-spinner mr-3" />
                                                    Loading Posts...
                                                </h3>
                                            ) : (
                                                <div key="no more posts" className="w-full">
                                                    <div
                                                        className="text-gray-400 my-8 text-center"
                                                        slot="no-more"
                                                    >
                                                        No more posts
                                                    </div>
                                                </div>
                                            )
                                        }
                                    >
                                        {pages.map((item, i) => {
                                            const itemNames = getItemNames(item);
                                            return (
                                                <CardSwitcher
                                                    key={i}
                                                    post={itemNames}
                                                    userLikes={userLikes}
                                                    lookup={lookup}
                                                    showPmbokModal={showPmbokModal}
                                                    showShareModal={showShareModal}
                                                    showFeedbackModal={showFeedbackModal}
                                                    cardFilterSelected={cardFilterSelected}
                                                    canProceed={canProceed}
                                                    isAuthenticated={isAuthenticated}
                                                    playlists={playlists}
                                                    feedbacks={feedbacks}
                                                    feedbackSentContentKeys={feedbackSentContentKeys}
                                                    fullcard={true}
                                                    propGroup={{
                                                        downloadedContentKeys,
                                                        setDownloadedContentKeys,
                                                    }}
                                                />
                                            )
                                        })}
                                    </InfiniteScroll>
                                </>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
            {contentItemsPosts && !pages.length && !isLoading && (
                <NotFoundForm userId={userId} canProceed={canProceed} />
            )}
            <Footer />
        </div>
    );
};
export default HomePage;
